/* CADEME - Sepet sozlesme onayi (v14, 15 Ekim 2026)
   Odeme butonu her zaman AKTIF gorunur. Kutucuk isaretli degilse butona basildiginda
   kucuk bir onay penceresi acilir; musteri "Okudum, onaylıyorum" diyerek tek dokunusla
   onay verir ve dogrudan odemeye gecer. Onay musterinin acik eylemiyle alinir. */
if (!customElements.get('nodus-cart-kvkk-consent')) {
  class NodusCartKvkkConsent extends HTMLElement {
    /** @type {HTMLInputElement | null} */
    #checkbox = null;

    /** @type {HTMLButtonElement | null} */
    #checkoutButton = null;

    /** @type {HTMLFormElement | null} */
    #cartForm = null;

    /** @type {HTMLElement | null} */
    #warning = null;

    /** @type {HTMLDialogElement | null} */
    #dialog = null;

    connectedCallback() {
      this.#checkbox = this.querySelector('[data-cart-kvkk-input]');
      this.#warning = this.querySelector('[data-cart-kvkk-warning]');
      this.#checkoutButton = this.closest('.cart__ctas')?.querySelector('#checkout') ?? null;

      if (!this.#checkbox || !this.#checkoutButton) return;

      const formId = this.#checkoutButton.getAttribute('form');
      this.#cartForm = formId ? document.getElementById(formId) : null;

      this.#checkoutButton.classList.remove('cart__checkout-button--kvkk-blocked');
      this.#checkoutButton.removeAttribute('aria-disabled');

      this.#checkbox.addEventListener('change', this.#handleChange);
      this.#checkoutButton.addEventListener('click', this.#handleCheckoutClick);
      this.#cartForm?.addEventListener('submit', this.#handleFormSubmit);
    }

    disconnectedCallback() {
      this.#checkbox?.removeEventListener('change', this.#handleChange);
      this.#checkoutButton?.removeEventListener('click', this.#handleCheckoutClick);
      this.#cartForm?.removeEventListener('submit', this.#handleFormSubmit);
      this.#dialog?.remove();
      this.#dialog = null;
    }

    #handleChange = () => {
      if (this.#checkbox?.checked) this.#hideWarning();
    };

    #needsConsent() {
      return Boolean(this.#checkbox && this.#checkoutButton && !this.#checkoutButton.disabled && !this.#checkbox.checked);
    }

    #handleCheckoutClick = (event) => {
      if (!this.#needsConsent()) return;

      event.preventDefault();
      event.stopPropagation();
      this.#openDialog();
    };

    #handleFormSubmit = (event) => {
      if (!this.#needsConsent()) return;

      const submitter = event.submitter;
      if (submitter instanceof HTMLButtonElement && submitter.name === 'checkout') {
        event.preventDefault();
        this.#openDialog();
      }
    };

    #openDialog() {
      const dialog = this.#getDialog();
      if (!dialog || typeof dialog.showModal !== 'function') {
        this.#showWarning();
        return;
      }
      dialog.showModal();
    }

    #getDialog() {
      if (this.#dialog) return this.#dialog;

      const links = this.querySelectorAll('.cart-kvkk__text a');
      const privacyHref = links[0]?.getAttribute('href') || '/policies/privacy-policy';
      const termsHref = links[1]?.getAttribute('href') || '/policies/terms-of-service';

      const dialog = document.createElement('dialog');
      dialog.className = 'cademe-consent';
      dialog.setAttribute('aria-labelledby', 'cademe-consent-title');
      dialog.innerHTML =
        '<div class="cademe-consent__box">' +
        '<p id="cademe-consent-title" class="cademe-consent__title">Ödemeye geçmeden önce</p>' +
        '<p class="cademe-consent__text">Siparişinizi tamamlamak için <a href="' + termsHref + '" target="_blank" rel="noopener">Mesafeli Satış Sözleşmesi</a> ile <a href="' + privacyHref + '" target="_blank" rel="noopener">Gizlilik Sözleşmesi</a>’ni onaylamanız gerekiyor.</p>' +
        '<button type="button" class="cademe-consent__ok" autofocus>Okudum, onaylıyorum · Ödemeye geç</button>' +
        '<button type="button" class="cademe-consent__cancel">Vazgeç</button>' +
        '</div>';

      dialog.querySelector('.cademe-consent__ok')?.addEventListener('click', () => {
        dialog.close();
        this.#confirmAndContinue();
      });

      dialog.querySelector('.cademe-consent__cancel')?.addEventListener('click', () => {
        dialog.close();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      document.body.appendChild(dialog);
      this.#dialog = dialog;
      return dialog;
    }

    #confirmAndContinue() {
      const checkbox = this.querySelector('[data-cart-kvkk-input]') || this.#checkbox;
      const button = this.closest('.cart__ctas')?.querySelector('#checkout') || this.#checkoutButton;
      if (!checkbox || !button) return;

      checkbox.checked = true;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      button.click();
    }

    #showWarning() {
      if (!this.#warning) return;

      this.#warning.hidden = false;
      this.#warning.focus();
    }

    #hideWarning() {
      if (!this.#warning) return;

      this.#warning.hidden = true;
    }
  }

  customElements.define('nodus-cart-kvkk-consent', NodusCartKvkkConsent);
}
